import { render, staticRenderFns } from "./RouteListOnDeliveryPage.vue?vue&type=template&id=45405e2f&scoped=true&"
import script from "./RouteListOnDeliveryPage.vue?vue&type=script&lang=js&"
export * from "./RouteListOnDeliveryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45405e2f",
  null
  
)

export default component.exports